
<ion-grid>
  <ion-row>
    <ion-col>




<ion-card>
  <ion-card-header style="padding:0">
    <ion-toolbar color="primary">
      <ion-title>Importálás Excelből</ion-title>
      <ion-buttons slot="end">
        <ion-button style="background: white; border-radius: 5px" [strong]="true"
           shape="round" color="secondary" size="small"><ion-icon slot="start" name="cloud-download"></ion-icon>Sablon letöltése</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-card-header>
  <ion-card-content style="margin:15px;">
<div
        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
        <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
          <div class="input-outline-container sc-ion-input-md">
            <div class="input-outline-start sc-ion-input-md"></div>
            <div class="input-outline-end sc-ion-input-md"></div>
          </div>
          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
            
      <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" [(ngModel)]="overwrite" [disabled]="cdis">
        Létező felhasználók adatainak frissítése / felülírása</ion-checkbox>
          </div>
        </label>
      </div>
      <small>Ha be van pipálva, a rendszerben lévő szülők adatait is frissíti a rendszer</small><br><br>
      <div
        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
        <label class="input-wrapper sc-ion-input-md">
          <div class="input-outline-container sc-ion-input-md">
            <div class="input-outline-start sc-ion-input-md"></div>
            <div class="input-outline-end sc-ion-input-md"></div>
          </div>
          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
            <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" [(ngModel)]="generateKeycloakImport" [disabled]="cdis">
              Keycloak import fájl generálása</ion-checkbox>
          </div>
        </label>
      </div>
      <small>Felhasználónév: email cím, ha van. Ideiglenes jelszó: születési dátum ÉÉÉÉHHNN formátumban.</small><br><br>
<div class="container" appDnd (fileDropped)="onFileDropped($event)">
          <input type="file" accept=".xlsx, .xls" #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event)" />
          <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
            <g fill="#3B454F" fill-rule="nonzero">
              <path
                d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
              <path
                d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
              <path
                d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
            </g>
          </svg>

          <h3>Húzza ide a fájlt (.xslx, .xls)</h3>
          <h3 style="    margin-bottom: 15px !important;">vagy</h3>
          <label for="fileDropRef">Tallózás</label>
        </div>
        <!-- KIR gondviselő-sablon: mit fog csinálni a feltöltés. A felhasználónevet
             mi osztjuk ki (G01/G02/G03), ezért látni kell előre, mi készül. -->
        <div *ngIf="kirOsszegzes" style="margin:12px 0;padding:10px 12px;border:1px solid #dde3ee;border-radius:8px;background:#fafbfe;color:#1b2430;font-size:13px">
          <b *ngIf="kirOsszegzes.forras === 'kreta'">KRÉTA gondviselő-export felismerve</b>
          <b *ngIf="kirOsszegzes.forras !== 'kreta'">KIR gondviselő-sablon felismerve</b>
          <div style="font-size:12px;color:#5a6472;margin-top:4px">
            <b>{{ kirOsszegzes.gondviselo }}</b> gondviselő <b>{{ kirOsszegzes.gyerek }}</b> gyerekhez.
            A felhasználónév a gyerek oktatási azonosítója + <code>G01</code>, <code>G02</code>… a fájl
            sorrendjében – ezt ismeri fel a belépés is.
            <span *ngIf="kirOsszegzes.tobbMintKetto">
              <b>{{ kirOsszegzes.tobbMintKetto }}</b> gyerekhez kettőnél több gondviselő tartozik; mindegyik bekerül.
            </span>
            <!-- A KRÉTA-export két ponton kevesebbet mond, mint a KIR-sablon: a nevet
                 egyben adja, és nem jelöli a törvényes képviselőt. Amit ilyenkor
                 következtetünk, azt ki kell írni – az importált adat különben úgy
                 néz ki, mintha a fájlban így állt volna. -->
            <div *ngIf="kirOsszegzes.forras === 'kreta'" style="margin-top:6px">
              A KRÉTA a gondviselő nevét <b>egy mezőben</b> adja, ezért a vezeték- és keresztnevet
              szét kell bontani – a lenti listában ellenőrizhető, és a bevitel után javítható.
              A <b>törvényes képviselő</b> jelölést az export nem tartalmazza: a rokonsági fokból
              következtetjük (testvér és egyéb nem rokoni kapcsolat kivételével jelöljük).
              <span *ngIf="kirOsszegzes.tartozkodasi">
                <b>{{ kirOsszegzes.tartozkodasi }}</b> gondviselőnél tartózkodási cím is érkezett.
              </span>
            </div>
            <div *ngIf="kirOsszegzes.ismeretlenGyerek.length" style="color:#8a6d00;margin-top:4px">
              <b>{{ kirOsszegzes.ismeretlenGyerek.length }}</b> gyerek oktatási azonosítója még nincs meg a
              rendszerben – a gondviselő létrejön, de a kapcsolat csak a tanuló importja után lesz látható.
            </div>
          </div>
        </div>

        <div class="files-list">
          <div class="single-file" *ngFor="let file of files; let i = index">
            <div class="file-icon" style="width: 50px">
              <img *ngIf="file?.name.slice(-3) == 'xls' ||file?.name.slice(-4) == 'xlsx'"
                src="assets/svg/excel-document-svgrepo-com.svg">
            </div>
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>

            <div class="delete" (click)="deleteFile(i)">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                <path fill="#B1B1B1" fill-rule="nonzero"
                  d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
              </svg>
            </div>
          </div>
        </div>
        <ion-button style="background: white; border-radius: 5px" [strong]="true" expand="block" [disabled]="!cdis" (click)="uploadData()"
           shape="round" color="primary" id="open-loading"><ion-icon slot="start" name="cloud-upload" ></ion-icon>Importálás</ion-button>
           <ion-loading trigger="open-loading1" message="Adatok feltöltése folyamatban, ne zárja be az ablakot!" spinner="crescent"></ion-loading>
      </ion-card-content>
    </ion-card>
  </ion-col>
  
    </ion-row>
  </ion-grid>



<!-- KIR-sablon: saját nézet. A lenti táblázat a BELSŐ formátum oszlopneveire van
     kötve, a KIR-fájlban viszont más kulcsok vannak – ott minden cella üres maradna.
     Itt épp azt mutatjuk, amit feltöltés előtt ellenőrizni kell: ki milyen
     felhasználónevet kap. -->
<div class="kir-elonezet" *ngIf="kirElonezet?.length">
  <h3>Betöltött gondviselők ({{ kirElonezet.length }})</h3>
  <div class="kir-burok">
    <table class="kir-tabla">
      <thead><tr>
        <th>Gyermek</th><th>Gyermek azonosítója</th><th>Gondviselő</th><th>Rokonság</th>
        <th>Felhasználónév</th><th>Telefon</th><th>E-mail</th><th>Lakcím</th><th>Tartózkodási cím</th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let e of kirElonezet" [class.ismeretlen]="!e.ismertGyerek">
          <td>{{ e.gyerek }}</td>
          <td>{{ e.oktazon }}
            <span class="jel" *ngIf="!e.ismertGyerek" title="Ez a tanuló még nincs a rendszerben.">nincs meg</span>
          </td>
          <td>{{ e.nev }}
            <span class="jel tk" *ngIf="e.torv_kepv" title="Törvényes képviselő">tk.</span>
          </td>
          <td>{{ e.rokonsag }}</td>
          <td><b>{{ e.username }}</b></td>
          <td>{{ e.telefon }}</td>
          <td>{{ e.email }}</td>
          <td>{{ e.cim }}</td>
          <td>{{ e.tart_cim }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ngx-datatable *ngIf="!kirElonezet?.length"
          class="ngx-datatable cronomitnew"
          [rows]="excelData" [sortType]="SortType.single" [columnMode]="ColumnMode.force" 
           [selectionType]="SelectionType.checkbox" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
          <ngx-datatable-column name="Oktatási azonosító" prop="username">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Felhasználónév</b>
              <span *ngIf="value">{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Név">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Név</b>
              {{ row["elo"] }} {{ row["vez"] }} {{ row["ker"] }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Anyja neve">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Anyja neve</b>
              {{ row["anya_vez"] }} {{ row["anya_ker"] }}
            </ng-template>
          </ngx-datatable-column>
          <!--ngx-datatable-column name="Műveletek">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Műveletek</b>
              <ion-button color="secondary" size="small" style="margin-top:0">
                <ion-icon slot="icon-only" name="search"></ion-icon>

              </ion-button>
            </ng-template>
          </ngx-datatable-column-->
          <ngx-datatable-column name="Születési hely">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Születési hely</b>
              {{ row["szul_hely"] }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Születési dátum">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Születési dátum</b>
              {{ row["szul_ido"] }}
            </ng-template>
          </ngx-datatable-column>
          <!--ngx-datatable-column name="Születési név">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Születési név</b>
              {{ row["Születési név előtag"] }} {{ row["Születési név vezetéknév"] }} {{ row["Születési név keresztnév"] }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Születési név">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Születési név</b>
              {{ row["Születési név előtag"] }} {{ row["Születési név vezetéknév"] }} {{ row["Születési név keresztnév"] }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="1. állampolgárság">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">1. állampolgárság</b>
              {{ row["1. állampolgárság"] }} 
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="2. állampolgárság">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">2. állampolgárság</b>
              {{ row["2. állampolgárság"] }} 
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Végzettség szintje">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Végzettség szintje</b>
              {{ row["Végzettség szintje"] }} 
            </ng-template>
          </ngx-datatable-column-->
          
        
        </ngx-datatable>
    
      
<div *ngIf="excelData && !kirElonezet?.length">
  <h3>Uploaded Data:</h3>
  <pre>{{ excelData | json }}</pre>
</div>
